import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ActionDirective } from '~contentful/directives/action/action.directive';
import { BannerComponent } from './components/banner/banner.component';
import { PageComponent } from './components/page/page.component';
import { ContentfulService } from './services/contentful.service';
import { AbTestSubjectComponent } from './components/ab-test-subject/ab-test-subject.component';
import { AssetComponent } from './components/asset/asset.component';
import { ContentfulRendererComponent } from './components/contentful-renderer/contentful-renderer.component';
import { StepsHelperComponent } from './components/steps-helper/steps-helper.component';
import { StepsHelperStepComponent } from './components/steps-helper-step/steps-helper-step.component';
import { RichTextComponent } from './components/rich-text/rich-text.component';
import { ImageComponent } from './components/image/image.component';
import { ButtonComponent } from './components/button/button.component';
import { ResponsiveImageComponent } from './components/responsive-image/responsive-image.component';

@NgModule({
  imports: [CommonModule, FlexLayoutModule],
  entryComponents: [
    PageComponent,
    AbTestSubjectComponent,
    BannerComponent,
    AssetComponent,
    StepsHelperComponent,
    StepsHelperStepComponent,
    ButtonComponent,
    ImageComponent,
    ResponsiveImageComponent,
    RichTextComponent,
  ],
  declarations: [
    BannerComponent,
    PageComponent,
    AbTestSubjectComponent,
    AssetComponent,
    ContentfulRendererComponent,
    ActionDirective,
    StepsHelperComponent,
    StepsHelperStepComponent,
    RichTextComponent,
    ImageComponent,
    ButtonComponent,
    ResponsiveImageComponent,
  ],
  exports: [ContentfulRendererComponent],
  providers: [ContentfulService],
})
export class ContentfulModule {}
